export default __webpack_public_path__ + "static/chichen-itza-9f6321bc636974e0e0f8e452774fd66e.jpg";